//
//
//
//
//
//
//
//
//
//
export default {
  methods: {
    handleNewError: function handleNewError() {
      window.console.log(a); // eslint-disable-line
    }
  }
};